// @mui
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

export default function IllustrationSuspend({ ...other }) {
  return (
    <Box {...other}>
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 902.974 541.889"
        width="100%"
        height="100%"
      >
        <g>
          <path
            d="M801.532,357.932c-6.306,19.106-28.073,36.084-21.57,50.135,2.474,5.34,4.957,10.927,6.1,16.633a29.022,29.022,0,0,1,.364,10.356c-2.345,14.879-16.268,24.762-29.215,32.458-.8.473-1.606.955-2.415,1.438-12.267,7.351-25.116,15.815-29.058,29.384-2.188,7.538-1.222,15.6-2.128,23.392a48.917,48.917,0,0,1-7.125,20.161H633.8c-7.341-8.09-6.73-21.688-1.143-31.226,5.981-10.209,16.081-17.146,25.2-24.693,7.874-6.524,15.55-14.377,18.555-23.955a29.106,29.106,0,0,0,1.054-4.641c.729-5.183.335-31.659,9.322-47.957,13.893-25.166,36.429-18.968,43.316-33.167,2.641-5.44,4.917-72.277,48.815-59.93A32.644,32.644,0,0,1,801.532,357.932Z"
            fill="#c1d8ed"
          />
          <path
            d="M881.829,462.439a20.062,20.062,0,0,1-4.04,2.148c-11.844,4.444-44.785,3.951-49.6,15.648-2.266,5.5-2.808,11.568-4.749,17.194-4.4,12.761-16.032,22.329-29.039,25.925-4.681,1.291-9.529,1.892-14.159,3.331-8.948,2.788-16.358,8.4-22.871,15.2H650.585a42.054,42.054,0,0,1,19.273-35.631c11.874-7.489,26.871-8.888,38.528-16.712,7.686-5.163,13.213-12.622,17.6-20.87a152.436,152.436,0,0,0,7.381-16.642c3.261-8.465,6.671-17.55,14.08-22.792a36.165,36.165,0,0,1,11.894-4.986c10.7-2.8,18.929-1.153,26.723.444,9.459,1.931,18.288,3.774,30.142-2.523,21.028-11.174,51.771-66.9,82.494-13.953C911.015,429.459,894.018,454.28,881.829,462.439Z"
            fill="#8ddbe0"
          />
        </g>
        <g>
          <path
            d="M101.442,357.932c6.307,19.106,28.074,36.084,21.57,50.135-2.473,5.34-4.957,10.927-6.1,16.633a29.022,29.022,0,0,0-.365,10.356c2.345,14.879,16.269,24.762,29.216,32.458.8.473,1.606.955,2.414,1.438,12.268,7.351,25.117,15.815,29.058,29.384,2.188,7.538,1.222,15.6,2.129,23.392a48.916,48.916,0,0,0,7.124,20.161h82.682c7.34-8.09,6.73-21.688,1.143-31.226-5.981-10.209-16.081-17.146-25.2-24.694-7.873-6.523-15.549-14.376-18.554-23.954a29.108,29.108,0,0,1-1.055-4.641c-.729-5.183-.335-31.659-9.321-47.957-13.894-25.166-36.429-18.968-43.317-33.167-2.64-5.44-4.917-72.277-48.814-59.93A32.645,32.645,0,0,0,101.442,357.932Z"
            fill="#c1d8ed"
          />
          <path
            d="M21.146,462.439a20.057,20.057,0,0,0,4.039,2.148c11.844,4.444,44.785,3.951,49.6,15.648,2.266,5.5,2.808,11.568,4.749,17.194,4.405,12.761,16.032,22.329,29.039,25.925,4.68,1.291,9.528,1.892,14.159,3.331,8.947,2.788,16.357,8.4,22.87,15.2H252.39a42.055,42.055,0,0,0-19.274-35.631c-11.873-7.489-26.871-8.888-38.528-16.712-7.685-5.163-13.213-12.622-17.6-20.87a152.238,152.238,0,0,1-7.38-16.642c-3.262-8.465-6.671-17.55-14.081-22.792a36.165,36.165,0,0,0-11.894-4.986c-10.7-2.8-18.928-1.153-26.722.444-9.46,1.931-18.289,3.774-30.143-2.523C65.743,411,35,355.281,4.276,408.224-8.041,429.459,8.956,454.28,21.146,462.439Z"
            fill="#8ddbe0"
          />
        </g>
        <g>
          <polygon
            points="628.382 451.658 278.531 451.658 278.531 0 553.927 0 628.382 78.685 628.382 451.658"
            fill="#f3f5fd"
          />
          <polygon points="553.927 0 553.927 78.685 628.382 78.685 553.927 0" fill="#dee8f5" />
        </g>
        <path
          d="M525.146,192.06v19.932a12.787,12.787,0,0,1-12.787,12.787H255.834a12.788,12.788,0,0,0-12.788,12.788V529.1a12.788,12.788,0,0,0,12.788,12.788H651.079A12.787,12.787,0,0,0,663.866,529.1V192.06a12.787,12.787,0,0,0-12.787-12.787H537.934A12.787,12.787,0,0,0,525.146,192.06Z"
          fill="#dee8f5"
        />
        <g>
          <circle cx="453.456" cy="383.022" r="95.953" fill="#f3f5fd" />
          <g>
            <path
              d="M490.591,366.03H485.3V354.214a31.846,31.846,0,0,0-63.691,0V366.03h-5.289a9.115,9.115,0,0,0-9.115,9.115V434.56a9.115,9.115,0,0,0,9.115,9.115h74.269a9.114,9.114,0,0,0,9.114-9.115V375.145A9.114,9.114,0,0,0,490.591,366.03Zm-58.628-11.816a21.493,21.493,0,0,1,42.986,0V366.03H431.963Z"
              fill="#F6A600"
            />
            <circle cx="453.456" cy="405.464" r="13.189" fill="#fff" />
          </g>
        </g>
      </svg>
    </Box>
  );
}
